const DEFAULT_TTL = 60000
let isNeedClean = false
const localCacheStore = {
  //{data:{}, expireTs:10000000000}
}

const checkAndRemoveExpired = (key)=> {
  if (localCacheStore[key].expireTs < Date.now()) {
    delete localCacheStore[key]
    return true
  }

  return false
}

const clean = () => {
  const keys = Object.keys(localCacheStore)

  if (isNeedClean) {
    if (keys.length === 0) {
      isNeedClean = false
      return
    }

    setTimeout(()=>{
      Object.keys(localCacheStore)
        .map(key => {
          checkAndRemoveExpired(key)
        })
      clean()
    }, DEFAULT_TTL)
  }
}

const localCache = {
  set: (key, data, ttl= DEFAULT_TTL)=>{
    localCacheStore[key] = { data, expireTs: Date.now()+ttl }
    isNeedClean = true
    clean()
  },
  get: (key)=>{
    if (!localCacheStore[key]) {
      return undefined
    }
    if (checkAndRemoveExpired(key)) {
      return undefined 
    }

    return localCacheStore[key].data
  },
}

module.exports = localCache
